export const CERT_TYPES = [
  { name: '身份证', value: '01' },
  { name: '户口薄', value: '02' },
  { name: '护照', value: '03' },
  { name: '军官证', value: '04' },
  { name: '驾驶证号码', value: '05' },
  { name: '税务编号', value: '06' },
  { name: '回乡证', value: '07' },
  { name: '台胞证', value: '08' },
  { name: '外籍在华驾驶证', value: '09' },
  { name: '军队驾驶证', value: '10' },
  { name: '组织机构证', value: '99' },
  { name: '统一信用证', value: 'B' },
  { name: '外国人永久居留身份证', value: 'C' },
  { name: '其他', value: '11' },
];

export const CaseStatus = {
  CS001: '1', // 立案
  CS002: '2', // 查勘赔案中
  CS003: '3', // 定价核损中
  CS004: '4', // 理算
  CS005: '5', // 核赔
  CS006: '6', // 零结案
  CS007: '7', // 结案
  CS008: '8', // 待支付
  CS009: '9', // 已支付
  CS010: '10', // 重开赔案
};
